<template>
    <div>
        <!-- My Pages Section -->
        <v-card class="mb-4" outlined>
            <v-card-title>{{$translate('My pages')}}</v-card-title>
            <v-card-text>
                <page-setting
                    v-model="$root.siteconfig.pages.mypages"
                    :label="$translate('My pages')"
                    :clearable="false"
                    @input="save"
                />
                <v-text-field
                    :label="$translate('Page parameter for tab name')"
                    v-model="$root.siteconfig.pages.mypagesTab"
                    @input="save"
                />
                <v-text-field
                    :label="$translate('Page parameter for group invite')"
                    v-model="$root.siteconfig.pages.mypagesGroupInvite"
                    @input="save"
                />
                <div v-if="hasTeamsports">
                    <v-text-field
                        :label="$translate('Page parameter for teamsport tab name')"
                        v-model="$root.siteconfig.pages.mypagesTeamsporttab"
                        @input="save"
                    />
                </div>
            </v-card-text>
        </v-card>

        <!-- Group Training Section -->
        <v-card class="mb-4" outlined>
            <v-card-title>{{$translate('Group training')}}</v-card-title>
            <v-card-text>
                <page-setting
                    v-model="$root.siteconfig.pages.grouptraining"
                    :label="$translate('Group training')"
                    :clearable="false"
                    @input="save"
                />
                <v-text-field
                    :label="$translate('Page parameter for workout')"
                    v-model="$root.siteconfig.pages.grouptrainingParam"
                    @input="save"
                />
            </v-card-text>
        </v-card>

        <!-- Courses Section -->
        <div v-if="hasCourses">
            <v-card class="mb-4" outlined>
                <v-card-title>{{$translate('Courses')}}</v-card-title>
                <v-card-text>
                    <page-setting
                        v-model="$root.siteconfig.pages.courses"
                        :label="$translate('Courses')"
                        :clearable="false"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for course name')"
                        v-model="$root.siteconfig.pages.coursesParamName"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for courseID')"
                        v-model="$root.siteconfig.pages.coursesParamId"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for course category')"
                        v-model="$root.siteconfig.pages.coursesParamCategoryId"
                        @input="save"
                    />
                </v-card-text>
            </v-card>
        </div>

        <!-- Shop Section -->
        <v-card class="mb-4" outlined>
            <v-card-title>{{$translate('Shop')}}</v-card-title>
            <v-card-text>
                <page-setting
                    v-model="$root.siteconfig.pages.shop"
                    :label="$translate('Shop')"
                    :clearable="false"
                    @input="save"
                />
                <v-text-field
                    :label="$translate('Page parameter for product name')"
                    v-model="$root.siteconfig.pages.productParamName"
                    @input="save"
                />
                <v-text-field
                    :label="$translate('Page parameter for productID')"
                    v-model="$root.siteconfig.pages.productParamId"
                    @input="save"
                />
            </v-card-text>
        </v-card>

        <!-- Teamsport Section -->
        <div v-if="hasTeamsports">
            <v-card class="mb-4" outlined>
                <v-card-title>{{$translate('Competitions')}}</v-card-title>
                <v-card-text>
                    <page-setting
                        v-model="$root.siteconfig.pages.teamsport"
                        :label="$translate('Competitions')"
                        :clearable="false"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for competitionID')"
                        v-model="$root.siteconfig.pages.competitionParamId"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for competition name')"
                        v-model="$root.siteconfig.pages.competitionParamName"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for teamsport category')"
                        v-model="$root.siteconfig.pages.teamsportParamCategoryId"
                        @input="save"
                    />
                    <page-setting
                        v-model="$root.siteconfig.pages.match"
                        :label="$translate('Match')"
                        :clearable="false"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for matchID')"
                        v-model="$root.siteconfig.pages.matchParamId"
                        @input="save"
                    />
                    <page-setting
                        v-model="$root.siteconfig.pages.gameClassOverview"
                        :label="$translate('Game class overview')"
                        :clearable="false"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for game class ID')"
                        v-model="$root.siteconfig.pages.gameClassOverviewParamId"
                        @input="save"
                    />
                    <page-setting
                        v-model="$root.siteconfig.pages.division"
                        :label="$translate('Division')"
                        :clearable="false"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for divisionID')"
                        v-model="$root.siteconfig.pages.divisionParamId"
                        @input="save"
                    />
                </v-card-text>
            </v-card>
        </div>

        <!-- Contract Section -->
        <div v-if="hasContract">
            <v-card class="mb-4" outlined>
                <v-card-title>{{$translate('Contract')}}</v-card-title>
                <v-card-text>
                    <page-setting
                        v-model="$root.siteconfig.pages.contract"
                        :label="$translate('Contract')"
                        :clearable="false"
                        @input="save"
                    />
                    <v-text-field
                        :label="$translate('Page parameter for contract ID')"
                        v-model="$root.siteconfig.pages.contractParamId"
                        @input="save"
                    />
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import PageSetting from './PageSetting.vue'

export default {
    name: 'StandardPageSettings',
    components: {
        PageSetting
    },
    computed: {
        hasTeamsports() {
            return this.$store.state?.settings?.teamsports != false;
        },
        hasCourses() {
            return this.$store.state?.settings?.modules.Courses;
        },
        hasContract() {
            return this.$store.state?.settings?.modules.Contract;
        }
    },
    methods: {
        save() {
            this.$root.saveHomePage();
        }
    }
}
</script>
